<template>
  <div
    class="myPage"
    :style="{ backgroundImage: 'url(' + imagePath.myBGI + ')' }"
  >
    <common-header></common-header>
    <div class="myContainer">
      <div class="breadCrumbs">
        <!-- <span>逻辑狗首页</span>>
        <span>{{ navList[navIndex].name }}</span> -->
        <address-bar :path="path"></address-bar>
      </div>
      <div class="myPageContent">
        <my-courseware v-if="navIndex === 1"></my-courseware>
        <my-collect v-if="navIndex === 2"></my-collect>
        <learning-record v-if="navIndex === 3"></learning-record>
        <div class="nav">
          <div
            v-for="item in navList"
            :key="item.id"
            @click="changeNavIndex(item.id)"
          >
            <div v-if="navIndex !== item.id">
              <div class="name">
                {{ item.name }}
              </div>
              <div class="EName">
                {{ item.EName }}
              </div>
            </div>
            <div v-else>
              <img :src="imagePath.LRSeleted" class="navItemImg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import imagePath from "@/utils/imagePath";
import CommonHeader from "@/components/header/index";
import MyCourseware from "@/views/my/myCourseware";
import LearningRecord from "@/views/my/learningRecord";
import MyCollect from "@/views/my/myCollect";
import AddressBar from "@/components/addressBar";

const navList = [
  // { id: 0, name: "个人信息", EName: "PERSONAL INFORMATION" },
  // { id: 1, name: "我的课件", EName: "MY COURSEWARE" },
  // { id: 2, name: "我的收藏", EName: "MY COLLECTION" },
  { id: 3, name: "学习记录", EName: "LEARNING RECORDS" }
];

export default {
  name: "MyPage",
  components: {
    CommonHeader,
    MyCourseware,
    LearningRecord,
    MyCollect,
    AddressBar
  },
  data() {
    return {
      imagePath,
      navList,
      navIndex: 3 // 右侧导航栏索引
    };
  },
  computed: {
    path() {
      return {
        firSubName: "逻辑狗首页",
        // secSubName: this.navList[this.navIndex - 1].name,
        secSubName: this.navList[0].name
      };
    }
  },
  methods: {
    changeNavIndex(val) {
      if (val) return;
      this.navIndex = val;
    }
  }
};
</script>

<style lang="less" scoped>
.myPage {
  // width: 100%;
  height: 100%;
  background-color: #ddf4ff;
  background-repeat: no-repeat;
  background-size: cover;

  .myContainer {
    margin: 0 auto;
    padding-bottom: 59px;
    width: 1200px;
    // height: 100vh;
    .breadCrumbs {
      margin-top: 64px;
      font-size: 24px;
      color: #333333;

      span:nth-child(2) {
        font-weight: 600;
      }
    }

    .myPageContent {
      display: flex;
      justify-content: space-between;
      margin-top: 62px;

      .nav {
        text-align: right;

        > div {
          margin-bottom: 44px;
        }

        .name {
          font-size: 20px;
          color: #333333;
          font-weight: 600;
        }

        .EName {
          font-weight: 550;
          font-size: 16px;
          color: #ccc;
        }

        .isSelected {
          color: #66a8f5;
          font-size: 44px;
        }

        .isSelected2 {
          color: #cce4ff;
          font-size: 24px;
        }

        .navItemImg {
          width: 272px;
          object-fit: cover;
        }
      }
    }
  }
}
</style>
